import React, { useEffect, useState } from "react";
import "./EditData.scss";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InputMask from "react-input-mask";

// Hook de autenticação
import { useAuthValidation } from "../../../hooks/useAuthValidation";
// API configurada
import api from "../../../services/api";
// Layout padrão
import DefaultLayout from "../../components/Layouts/DefaultLayout";

function EditData() {
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation();
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [userData, setUserData] = useState({});
  const [profileValue, setProfileValue] = useState("");
  const [formUser, setFormUser] = useState({
    email: "",
    profile_value: "",
    name: "",
    profile_name: "",
    phone: "",
  });

  // Carregamento de dados do usuário após confirmação da autenticação
  useEffect(() => {
    if (!loading && user) {
      // user já disponível aqui através do hook
      setUserData(user);
      setProfileValue(user.profile?.value || "");
      setFormUser({
        email: user.email || "",
        name: user.name || "",
        profile_name: user.profile?.name || "",
        phone: user.phone || "",
      });
    }
  }, [loading, user]);

  // Enquanto estiver carregando a validação
  if (loading) {
    return <div className="loading">{t("loading")}</div>;
  }

  // Se não houver usuário, significa que já houve redirecionamento
  if (!user) {
    return null;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    api
      .post("/user/update", formUser, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        navigate("/perfil");
      })
      .catch((error) => {
        console.error("Erro:", error);
        // Você pode ajustar a lógica de erros conforme necessário,
        // por exemplo, setar errors do back-end no estado `errors`.
      });
  };

  const maskValue =
    userData.profile_type === "veterinarian"
      ? "999/9"
      : userData.profile_type === "attendant"
      ? "99.999.999/9999-99"
      : userData.profile_type === "breeder"
      ? "999.999.999-99"
      : "";

  return (
    <DefaultLayout>
      <section className="editData">
        <div className="container">
          <span>{t("edit-data-title")}</span>
          <form onSubmit={handleSubmit}>
            <div>
              <input
                placeholder={t("edit-data-input-1")}
                name="name"
                onChange={handleChange}
                type="text"
                value={formUser.name}
                required
              />
              {errors.name && <p className="error">{errors.name}</p>}
            </div>
            <div>
              <input
                placeholder={t("edit-data-input-2")}
                name="profile_name"
                onChange={handleChange}
                type="text"
                value={formUser.profile_name}
                required
              />
              {errors.profile_name && <p className="error">{errors.profile_name}</p>}
            </div>
            <div>
              <InputMask
                mask={maskValue}
                placeholder={t("edit-data-input-3")}
                name="profile_value"
                type="text"
                disabled
                value={profileValue}
              />
              {errors.profile_value && <p className="error">{errors.profile_value}</p>}
            </div>
            <div>
              <input
                placeholder={t("edit-data-input-4")}
                name="phone"
                onChange={handleChange}
                type="phone"
                value={formUser.phone}
                required
              />
              {errors.phone && <p className="error">{errors.phone}</p>}
          </div>
            <div>
              <input
                placeholder={t("edit-data-input-5")}
                name="email"
                onChange={handleChange}
                type="email"
                value={formUser.email}
                required
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>
            {errors.general && <p className="error">{errors.general}</p>}
            <button type="submit">{t("edit-data-button")}</button>
          </form>
        </div>
      </section>
    </DefaultLayout>
  );
}

export default EditData;
